export const UiBreakpoints = {
	xs: 375,
	xsWide: 475,
	sm: 640,
	md: 768,
	lg: 1024,
	xl: 1280,
	"2xl": 1535,
};
